export const ACCESS_TOKEN = 'access_token'
export const LAST_OPER_TIME = 'last_oper_time'